<template>
	<v-card>
    <v-toolbar
      color="deep-orange accent-2"
      dark
      tabs
    >

      <v-icon large>monetization_on</v-icon>

      <v-toolbar-title>อัตราค่าตอบแทน</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-tabs
        slot="extension"
        v-model="model"
        color="deep-orange accent-2"
        slider-color="yellow"
      >
        <v-tab
          href="#tab-lastestRates"
        >
          <span class="subheading">อัตราล่าสุด</span>
        </v-tab>

        <v-tab
          href="#tab-settings"
        >
          <span class="subheading">ตั้งค่า</span>
        </v-tab>
      </v-tabs>
    </v-toolbar>

    <v-tabs-items v-model="model">
      <v-tab-item
        value="tab-lastestRates"
      >
        <v-card flat>
          <v-card-text>
						<lastest-rates :lastestRateItems="lastestRateItems"></lastest-rates>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item
        value="tab-settings"
      >
        <v-card flat>
          <v-card-text>
          	<settings :lastestRateItems="lastestRateItems"></settings>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
    <v-card-actions>
      <!-- <v-btn flat color="orange">Share</v-btn>
      <v-btn flat color="orange">Explore</v-btn> -->
    </v-card-actions>
  </v-card>
</template>

<script>
import LastestRates from './lastestRates'
import Settings from './settings'

export default {
	components: {
		LastestRates,
		Settings
	},
	data () {
		return {
			model: null,
			active: null,
			lastestRateItems: []
		}
	},
	mounted () {
		this.reload ()
	},
	methods: {
		reload () {
			this.loading = true
			this.$store.dispatch("wageRate/loadLastestRateItems")
    		.then((response) => {
    			console.log("wageRate reload", response)
    			this.loading = false
          this.lastestRateItems = response.data
        }).catch((error)=>{
          console.log('reload', error)
          this.loading = false
        })
		}
	},
	watch: {
		model (newVal, oldVal) {
			console.log("newVal", newVal)
			console.log("oldVal", oldVal)
			if(newVal === "tab-lastestRates" && oldVal === "tab-settings") this.reload ()
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/settings/wageRate/index.vue